import { useState } from 'react';
import { Country } from '../../../utils/ContextProviders/appContextTypes';
import { getGDPRStatusFromCountry } from '../../../utils/Data/registerConnector';

export function useHandleNewsletterOptIn(countries: Country[], shipCountry: string) {
  const [isOptIn, setIsOptIn] = useState(!getGDPRStatusFromCountry(countries, shipCountry));
  const handleOnSelect = () => {
    if (getGDPRStatusFromCountry(countries, shipCountry)) {
      setIsOptIn(!isOptIn);
    }
  };
  return {
    isOptIn,
    setIsOptIn,
    handleOnSelect,
  };
}

export default useHandleNewsletterOptIn;
